import * as React from 'react';

import styles from './numbered-list.module.css';

type Item = React.ReactNode | string;

type Props = {
    items: Item[];
    size: 'normal' | 'big';
};

export function NumberedList(props: Props) {
    return (
        <ul className={styles[`numbered-list--${props.size}`]}>
            {props.items.map((item, index) => {
                return (
                    <li key={index}>
                        <div className='flex'>
                            {index + 1}.&nbsp;{item}
                        </div>
                    </li>
                );
            })}
        </ul>
    );
}
